import { render } from "./PlanningLogPage.vue?vue&type=template&id=54c37a4f&scoped=true"
import script from "./PlanningLogPage.vue?vue&type=script&lang=js"
export * from "./PlanningLogPage.vue?vue&type=script&lang=js"

import "./PlanningLogPage.vue?vue&type=style&index=0&id=54c37a4f&lang=scss&scoped=true"

import exportComponent from "/home/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c37a4f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QSeparator});
